import { useSelector } from 'modules/react-redux';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { XeroRequest } from 'pages/requestForm/selectors/xero';

export const useXeroRequest = () => {
    return <XeroRequest>useSelector(requestSelector);
};
